// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const defaultTheme = {
  dark: false,
  colors: {
    primary: '#eb5c37',
    secondary: '#40424c',
    tertiary: 'black',
    title: "#9e9e9e",
    featureHighlight: "#9e9e9e",
    dialogColor: '#eb5c37',
    accent: '#9e9e9e',
    error: '#b71c1c',
    tabColor: '#eb5c37',
    tableColor: '',
    fontColor: '#36454F',
  },
  options: {
    customProperties: true
  }
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'defaultTheme',
    themes: {
      defaultTheme,
    }
  }
})
